import { Grid } from '@material-ui/core'

interface GridContainerProps {
  isMobile?: boolean
  children: any
  className?: string
}

const GridContainer = ({
  isMobile,
  className,
  children
}: GridContainerProps) => (
  <Grid
    container
    className={className}
    alignItems={isMobile ? 'center' : 'flex-start'}
    justify={isMobile ? 'center' : 'flex-start'}
  >
    {children}
  </Grid>
)

export default GridContainer
